import React from 'react';

import FloatingCallout from '../../components/Common/FloatingCallout';
import ImageBleedCallout from '../../components/Common/ImageBleedCallout';
import FullSectionCard from '../../components/PageSections/FullSectionCard';

export const ContentfulSectionCallout = (section, i, styles) => {
  if (section.style === 'Floating') {
    return <FloatingCallout key={i} section={section} />;
  } else if (section.style === 'Image Vertical Bleed') {
    return <ImageBleedCallout key={i} section={section} />;
  }
  return (
    <FullSectionCard
      key={i}
      label={section.ctaLabel}
      heading={section.title}
      backColor={section.backgroundOverlayColor}
      imageSrc={section.mainImage?.file?.url ? section.mainImage.file.url : ''}
      backImageSrc={section.backgroundImage ? section.backgroundImage.file.url : ''}
      link={section.ctaUrl}
      position={section.imagePosition}
      section={section}
    />
  );
};
